import { useEffect, useState } from "react";
import Parser from 'html-react-parser'
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import { API_GATEWAY_API_KEY, GET_TERMS_ENDPOINT } from "constants/base"
import { Terms } from "gql/graphql"
import "react-quill/dist/quill.snow.css"

function TermPage() {
  const [terms, setTerms] = useState<Terms | null>(null)
  const [content, setContent] = useState("")
  const [language, setLanguage] = useState("JP")

  const changeLanguage = () => {
    switch (language) {
      case "JP":
        setContent(terms?.content || '')
        break
      case "EN":
        setContent(terms?.contentEn || '')
        break
    }
  }

  useEffect(() => {
    try {
      fetch(GET_TERMS_ENDPOINT, {
        mode: "cors",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_GATEWAY_API_KEY
        },
      }).then((res) => {
        res.json().then((res) => {
          setTerms({
            termsId: res.termsId,
            content: res.content,
            contentEn: res.contentEn,
            updateDate: res.updateDate,
            button: res.button,
            buttonEn: res.buttonEn,
          })
        })
      })
    } catch (e) {
      console.log("get terms error")
    }
  }, [])

  useEffect(() => {
    changeLanguage()
  }, [language])

  useEffect(() => {
    changeLanguage()
  }, [terms])

  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: '800px',
        height: '100%',
        boxSizing: 'border-box',
        padding: '20px',
        whiteSpace: 'wrap',
        wordBreak: 'break-word',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack direction="row" gap={2}>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => setLanguage("JP")}
        >
          {"日本語"}
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => setLanguage("EN")}
        >
          {"English"}
        </Button>
      </Stack>
      <Box
        className="ql-editor"
        sx={{
          margin: '20px 0',
          overflowY: 'auto',
        }}
      >
        {Parser(String(content))}
      </Box>
    </Box>
  )
}

export default TermPage
